import { createSlice } from '@reduxjs/toolkit'

export const openSimulatorDRGSlice = createSlice({
    name: 'openSimulatorDRG',
    initialState: {
        open: false,
    },
    reducers: {
        setOpenSimulatorDRG: (state, action) => {
            state.open = action.payload;
        },
    },
})

export const { setOpenSimulatorDRG } = openSimulatorDRGSlice.actions;

export const getOpenSimulatorDRG = (state) => state.openSimulatorDRG.open;

export default openSimulatorDRGSlice.reducer